export * from "./message-resource";